import runningKnight from './knight_running.png'
import React from 'react';

const LoadingPage = () => {
    return <img style={{ width: '1000px', maxWidth: '100%', height: 'auto', margin: 'auto', }} src={runningKnight} alt='running knight' />
}

export default LoadingPage;